const validNonCharKey = (key) => {
  const ARROWLEFT = 'ArrowLeft',
    ARROWRIGHT = 'ArrowRight',
    DELETE = 'Delete',
    BACKSPACE = 'Backspace',
    TAB = 'Tab';
  return (key === ARROWLEFT
    || key === ARROWRIGHT
    || key === DELETE
    || key === BACKSPACE
    || key === TAB);
};

const nameFieldPattern = /^[0-9a-zA-Z'\-\.,/&\+\(\) ]+$/;

const isCopyPaste = (e) => {
  const key = e.key;
  if ((e.metaKey || e.ctrlKey) && (key === 'c' || key === 'v' || key === 'x' || key === 'a')) {
    return true;
  }
  return false;
};

export const validNameKey = (e) => {
  let key = e.key;
  if (key && key === 'Unidentified') {
    key = String.fromCharCode(e.which ? e.which : e.keyCode);
  }

  if (!(nameFieldPattern.test(key) || validNonCharKey(key) || isCopyPaste(e))) {
    e.preventDefault();
  }
};

export const validNumKey = (e) => {
  let key = e.key;
  if (key && key === 'Unidentified') {
    key = String.fromCharCode(e.which ? e.which : e.keyCode);
  }

  const condition = /[0-9]/;
  if (!(condition.test(key) || validNonCharKey(key) || isCopyPaste(e))) {
    e.preventDefault();
  }
};

export const handleOnPasteForNameField = (e) => {
  const value = (e.originalEvent || e).clipboardData.getData('text/plain');
  for (let c of value) {
    if (!(nameFieldPattern.test(c))) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
};

